//import update from 'immutability-helper';

const emptyState = {
  data: {}
}

const FundingReducer = (state = emptyState, action) => {
  switch (action.type) {
    default: {
      return state
    }
  }
}

export default FundingReducer